import FdxIconAccountBalance from '~icons/icon/account_balance';
import FdxIconBidLandscape from '~icons/icon/bid_landscape';
import FdxIconCardioLoad from '~icons/icon/cardio_load';
import FdxIconContactPage from '~icons/icon/contact-page';
import FdxIconContactEdit from '~icons/icon/contract_edit';
import FdxIconHandshake from '~icons/icon/handshake';
import FdxIconInventory from '~icons/icon/inventory';
import FdxIconLocalAtm from '~icons/icon/local_atm';
import FdxIconLocalShipping from '~icons/icon/local_shipping';
import FdxIconPeopleAlt from '~icons/icon/people_alt';
import FdxIconPercent from '~icons/icon/percent';
import FdxIconRequestQuote from '~icons/icon/request_quote';
import FdxIconShieldPerson from '~icons/icon/shield_person';
import FdxIconToysAndGames from '~icons/icon/toys_and_games';

export default [
  {
    children: [
      {
        activeSidebarItemId: 'merchants',
        authority: 'merchants:view',
        label: 'Merchants',
        name: 'merchants',
        route: '/merchants',
      },
      {
        activeSidebarItemId: 'merchants-requests',
        authority: 'pending_reviews:view',
        label: 'Merchants Requests',
        name: 'merchants-requests',
        route: '/merchants-requests',
      },
      {
        activeSidebarItemId: 'customer-portal-users',
        authority: 'merchant_users:view',
        label: 'Merchant Users',
        name: 'customer-portal-users',
        route: '/customer-portal-users',
      },
      {
        activeSidebarItemId: 'partners',
        authority: 'partners:view',
        label: 'Partners',
        name: 'partners',
        route: '/partners',
      },
      {
        activeSidebarItemId: 'cr-details',
        authority: 'merchants:view_cr_details',
        label: 'CR Details',
        name: 'cr-details',
        route: '/cr-details',
      },
      {
        activeSidebarItemId: 'loans',
        authority: 'loans:view',
        label: 'Loans',
        name: 'loans',
        route: '/loans',
      },
    ],
    icon: FdxIconPeopleAlt,
    label: 'Customers',
    name: 'customers',
  },
  {
    children: [
      {
        activeSidebarItemId: 'onboard-requests',
        authority: 'onboard_requests:view',
        label: 'Requests',
        name: 'onboard-requests',
        route: '/onboard-requests',
      },
      {
        activeSidebarItemId: 'tms-registration',
        authority: 'tms_registration:view',
        label: 'TMS Registration',
        name: 'tms-registration',
        route: '/tms-registration',
      },
      {
        activeSidebarItemId: 'bank-registration',
        authority: 'bank_registration:view',
        label: 'Bank Registration',
        name: 'bank-registration',
        route: '/bank-registration',
      },
      {
        activeSidebarItemId: 'installation',
        authority: 'terminal_installation:view',
        label: 'Installation',
        name: 'installation',
        route: '/installation',
      },
    ],
    icon: FdxIconHandshake,
    label: 'Onboarding',
    name: 'onboarding',
  },
  {
    activeSidebarItemId: 'requests',
    authority: 'pending_reviews:view',
    icon: FdxIconContactEdit,
    label: 'Change Requests',
    name: 'change-requests',
    route: '/requests',
  },
  {
    activeSidebarItemId: 'transactions',
    authority: 'transactions:view',
    icon: FdxIconBidLandscape,
    label: 'Transactions',
    name: 'transactions',
    route: '/transactions',
  },
  {
    activeSidebarItemId: 'payments',
    authority: 'payments:view',
    icon: FdxIconLocalAtm,
    label: 'Payouts',
    name: 'payments',
    route: '/payments',
  },
  {
    activeSidebarItemId: 'adjustments',
    authority: 'adjustments:view',
    icon: FdxIconRequestQuote,
    label: 'Adjustments',
    name: 'adjustments',
    route: '/adjustments',
  },
  {
    activeSidebarItemId: 'account-statement-generator',
    authority: 'account_statements:download',
    icon: FdxIconContactPage,
    label: 'Account Statement',
    name: 'account-statement-generator',
    route: '/account-statement-generator',
  },
  {
    activeSidebarItemId: 'supply',
    authority: 'supply:view',
    icon: FdxIconLocalShipping,
    label: 'Supply',
    name: 'supply',
    route: '/supply',
  },
  {
    children: [
      {
        activeSidebarItemId: 'vat-statements',
        authority: 'vat_statements:view',
        label: 'Monthly Statements',
        name: 'vat-statements',
        route: '/vat-statements',
      },
      {
        activeSidebarItemId: 'vat-invoice',
        authority: 'vat_invoices:download',
        label: 'Monthly Invoice',
        name: 'vat-invoice',
        route: '/vat-invoice',
      },
    ],
    icon: FdxIconPercent,
    label: 'VAT',
    name: 'vat',
  },
  {
    children: [
      {
        activeSidebarItemId: 'terminals',
        authority: 'terminals:view',
        label: 'Terminals',
        name: 'terminals',
        route: '/terminals',
      },
      {
        activeSidebarItemId: 'devices',
        authority: 'devices:view',
        label: 'Devices',
        name: 'devices',
        route: '/devices',
      },
      {
        activeSidebarItemId: 'tids',
        authority: 'tids:view',
        label: 'TIDs',
        name: 'tids',
        route: '/tids',
      },
    ],
    icon: FdxIconInventory,
    label: 'Inventory',
    name: 'inventory',
  },
  {
    children: [
      {
        activeSidebarItemId: 'health-banks',
        authority: 'health_dashboard:index',
        label: 'Banks',
        name: 'health-banks',
        route: '/health-banks',
      },
      {
        activeSidebarItemId: 'health-system',
        authority: 'health_dashboard:index',
        label: 'System',
        name: 'health-system',
        route: '/health-system',
      },
    ],
    icon: FdxIconCardioLoad,
    label: 'Health',
    name: 'health-dashboard',
  },
  {
    children: [
      {
        activeSidebarItemId: 'banks',
        authority: 'banks:view',
        label: 'Banks List',
        name: 'banks-list',
        route: '/banks',
      },
      {
        activeSidebarItemId: 'channels',
        authority: 'channels:view',
        label: 'Channels',
        name: 'channels',
        route: '/channels',
      },
      {
        activeSidebarItemId: 'account-balances',
        authority: 'account_balances:view',
        label: 'Account Balances',
        name: 'account-balances',
        route: '/account-balances',
      },
      {
        activeSidebarItemId: 'mt940-statements',
        authority: 'account_statements:view',
        label: 'MT940 Statements',
        name: 'mt940-statements',
        route: '/mt940-statements',
      },
      {
        activeSidebarItemId: 'mt942-statements',
        authority: 'account_statements:view',
        label: 'MT942 Statements',
        name: 'mt942-statements',
        route: '/mt942-statements',
      },
    ],
    icon: FdxIconAccountBalance,
    label: 'Banks',
    name: 'banks',
  },
  {
    children: [
      {
        activeSidebarItemId: 'recon-dashboard',
        authority: 'recon_tool:view',
        label: 'Recon Dashboard',
        name: 'recon-dashboard',
        route: '/recon-dashboard',
      },
      {
        activeSidebarItemId: 'recon-financial-records',
        authority: 'bank_statement_transactions:view',
        label: 'Recon Records',
        name: 'recon-financial-records',
        route: '/recon-financial-records',
      },
      {
        activeSidebarItemId: 'recon-unparsed-records',
        authority: 'bank_statement_transactions:view',
        label: 'Unparsed Records',
        name: 'recon-unparsed-records',
        route: '/recon-unparsed-records',
      },
      {
        activeSidebarItemId: 'alinma-bank-to-system',
        authority: 'banks_recons:view',
        label: 'Alinma to System',
        name: 'alinma-bank-to-system',
        route: '/alinma-bank-to-system',
      },
      {
        activeSidebarItemId: 'riyadh-bank-to-system',
        authority: 'banks_recons:view',
        label: 'Riyadh to System',
        name: 'riyadh-bank-to-system',
        route: '/riyadh-bank-to-system',
      },
      {
        activeSidebarItemId: 'anb-bank-to-system',
        authority: 'banks_recons:view',
        label: 'ANB to System',
        name: 'anb-bank-to-system',
        route: '/anb-bank-to-system',
      },
      {
        activeSidebarItemId: 'system-to-alinma-bank',
        authority: 'banks_recons:view',
        label: 'System to Alinma',
        name: 'system-to-alinma-bank',
        route: '/system-to-alinma-bank',
      },
      {
        activeSidebarItemId: 'system-to-riyadh-bank',
        authority: 'banks_recons:view',
        label: 'System to Riyadh',
        name: 'system-to-riyadh-bank',
        route: '/system-to-riyadh-bank',
      },
      {
        activeSidebarItemId: 'system-to-anb-bank',
        authority: 'banks_recons:view',
        label: 'System to ANB',
        name: 'system-to-anb-bank',
        route: '/system-to-anb-bank',
      },
    ],
    icon: FdxIconToysAndGames,
    label: 'Reconciliation',
    name: 'reconciliation',
  },
  {
    children: [
      {
        activeSidebarItemId: 'users',
        authority: 'foodics_users:view',
        label: 'Foodics Users',
        name: 'users',
        route: '/users',
      },
      {
        activeSidebarItemId: 'integration-logs',
        authority: 'integration_logs:view',
        label: 'Integration Logs',
        name: 'integration-logs',
        route: '/integration-logs',
      },
      {
        activeSidebarItemId: 'external-documents',
        authority: 'external_documents:view',
        label: 'External Documents',
        name: 'external-documents',
        route: '/external-documents',
      },
      {
        activeSidebarItemId: 'audit-logs',
        authority: 'audit_logs:view',
        label: 'Audit Logs',
        name: 'audit-logs',
        route: '/audit-logs',
      },
      {
        activeSidebarItemId: 'sama-integration',
        authority: 'sama_finance:view',
        label: 'Sama Integration',
        name: 'sama-integration',
        route: '/sama-integration',
      },
    ],
    icon: FdxIconShieldPerson,
    label: 'Administration',
    name: 'administration',
  },
];
